import router from "@/router";
import axios from "axios";
import qs from 'qs';
import { showMessage } from "./message";

const service = axios.create({
    // 测试地址
    // baseURL: 'http://158.1.83.204:8080/tb',
    // baseURL: 'http://158.58.60.29:8080',
    baseURL: '/web-connect/tb',
    timeout: 20000
})

// 请求拦截
service.interceptors.request.use(
    config=>{
        const token = sessionStorage.getItem('X-Access-Token');
        if(token) {
            config.headers['X-Access-Token'] = token;
            config.headers['version'] = '1.0.0'
        }
        if(!(config.data instanceof FormData)) {
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
            config.data = qs.stringify(config.data);
        }
        return config;
    },
    error=>{
        console.log(error);
        Promise.reject(new Error(error));
    }
)
// 响应拦截
service.interceptors.response.use(
    response=>{
        const res = response.data;   // 具体根据数据返回情况修改，如果数据不规则，不需要响应拦截  如果是json字符串数据 转化为json对象
        if(res.code=='500') {
            if(res.message === '无效的token,请重新登录') {
                sessionStorage.removeItem('X-Access-Token')
                showMessage('token已过期，请重新进行登录', 'info')
                router.push('/login')
                return;
            } else {
                showMessage(res.message, 'info')
            }
            
            // 这里在提示token过期的时候，把token去掉,跳转到登录页面

        }
         return res;
    },
    error=>{
        console.log(error, 'err');
        return Promise.resolve({error: '请求失败，请稍后再试'})
    }
)

export default service;